// Talks to GET /api/v1/customer/context. Called after sign-in to fetch the user's enriched
// customer context (Shopper subscriptions), which the backend reads on-behalf-of the user.
import { authHeaders, type AuthArgs } from './authArgs';

export interface CustomerSubscription {
  productName?: string | null;
  skuTitle?: string | null;
  state?: string | null;
  isTrial: boolean;
  autoRenewEnabled: boolean;
  renewalDateUtc?: string | null;
  market?: string | null;
  productFamily?: string | null;
}

export interface CustomerContext {
  authenticated: boolean;
  subscriptions: CustomerSubscription[];
  /** Server-side time (ms) spent reading the Shopper commerce profile on-behalf-of the user. */
  shopperLatencyMs: number;
  /** Client-measured end-to-end round-trip (ms) for this fetch — request sent to response parsed. */
  roundTripMs: number;
}

export async function getCustomerContext(auth: AuthArgs): Promise<CustomerContext> {
  const start = performance.now();
  const res = await fetch('/api/v1/customer/context', {
    method: 'GET',
    headers: authHeaders(auth, false),
    credentials: 'same-origin',
  });
  if (!res.ok) {
    throw new Error(`customer context ${res.status}: ${await res.text()}`);
  }
  const body = (await res.json()) as {
    authenticated: boolean;
    subscriptions: CustomerSubscription[];
    shopperLatencyMs?: number;
  };
  const roundTripMs = performance.now() - start;
  return {
    authenticated: body.authenticated,
    subscriptions: body.subscriptions ?? [],
    shopperLatencyMs: body.shopperLatencyMs ?? 0,
    roundTripMs,
  };
}